import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import './AboutUs.css';
import axios from 'axios';

const AboutUs = () => {
  const [metaTags, setMetaTags] = useState([]);

  useEffect(() => {
    document.title = "About Us - Clever Coverage";

    const fetchMetaTags = async () => {
      try {
        const res = await axios.get('https://api.funfillia.com/api/v2/website/metaTags/about_us', {
          headers: {
            Accept: 'application/json',
            'Client-Domain': 'www.clevercoverageofficial.com',
          },
        });

        const htmlString = res.data?.metaTags || '';
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);
      } catch (err) {
        console.error("Error fetching meta tags for About Us:", err);
      }
    };

    fetchMetaTags();
  }, []);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find(t => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return (
    <>
      <Helmet>
        <title>About Us - Clever Coverage</title>
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />
        <link rel="canonical" href={window.location.href} />
        <meta property="og:type" content={getMetaContent('property', 'og:type')} />
        <meta property="og:url" content={getMetaContent('property', 'og:url')} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />
        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
      </Helmet>

      <div className="about-container">
        <div className="hero-section">
          <h1>About Clever Coverage</h1>
          <p>Smart stories for a fast-changing world — from business trends to digital breakthroughs.</p>
        </div>

        <div className="mission-section">
          <h2>Our Mission</h2>
          <p>
            Welcome to <strong>Clever Coverage</strong> — your daily source of curated insight across trending topics, economic shifts, tech innovation, cultural buzz, finance hacks, and gaming evolution.
            We bring clarity to complex issues, spotlight smart solutions, and deliver content that keeps you informed and empowered.
          </p>
        </div>

        <div className="mission-section">
          <h2>What We Cover</h2>
          <p>
            Our platform is structured around 6 core categories:
          </p>
          <ul>
            <li><strong>Trending Now & Current Affairs:</strong> News, opinions, and real-time analysis of global events</li>
            <li><strong>Business & Economy Watch:</strong> Market shifts, policy moves, startup ecosystems, and investment insight</li>
            <li><strong>Science, Tech & Innovation:</strong> From AI to space, explore how technology is shaping the future</li>
            <li><strong>Culture, Celebrities & Entertainment:</strong> Pop culture, creators, and entertainment spotlights</li>
            <li><strong>Money, Finance & Life Hacks:</strong> Smart money tips, side hustles, savings strategies, and practical hacks</li>
            <li><strong>Gaming & Digital Competitions:</strong> From esports to mobile gaming, discover the edge of digital play</li>
          </ul>
        </div>

        <div className="mission-section">
          <h2>Why Clever Coverage?</h2>
          <p>
            In an age of noise and overload, we believe in relevance, research, and readability. Our goal is to filter out the fluff and fuel your curiosity with credible, concise, and compelling content.
          </p>

          <h2>Join the Movement</h2>
          <p>
            Whether you’re a curious reader, a digital explorer, or a passionate thinker — Clever Coverage is your space to stay updated, think deeper, and explore smarter.
          </p>

          <p className="closing-text">
            🔍 Stay sharp. Stay informed. <br />
            — The <strong>Clever Coverage</strong> Team
          </p>
        </div>
      </div>

    </>
  );
};

export default AboutUs;
